export default __webpack_public_path__ + "static/media/commercial_karier.336b0b20.png";